import React, { useEffect, useState } from 'react';
import { OrganizationsTableCardComponent } from '../../../../components/Cards/Organization';
import { IOrganization } from '../../../../modules/unsw-fhir/Organization';
import { getOrganizations } from '../../../../apis/organization';
import { usePractitioner } from '../../../../contexts/practitioner';

const OrganizationTableCard = () => {
  const [organizations, setOrganizations] = useState<IOrganization[]>([]);
  const [loading, setLoading] = useState(true);
  const { getRoles } = usePractitioner();

  useEffect(() => {
    const tsk = async () => {
      setLoading(true);
      const orgs = await getOrganizations();
      const filtered = orgs.filter(org =>
        getRoles(org.id).some(
          role =>
            (role.active &&
              (role.code === 'nurse' || role.code === 'researcher')) ||
            role.code === 'ict',
        ),
      );
      setOrganizations(filtered);
      setLoading(false);
    };
    tsk();
  }, [getRoles]);
  return (
    <OrganizationsTableCardComponent
      loading={loading}
      organizations={organizations}></OrganizationsTableCardComponent>
  );
};

export default OrganizationTableCard;
